export default {
  'cost.label.reportType': 'Selecione o tipo de relatório',
  'cost.label.budgetType': 'Tipo de orçamento',
  'cost.label.status': 'Situação',
  'cost.label.filterByDate': 'Filtrar por data de',

  'cost.option.costXSale': 'Custo x Venda (Peças)',
  'cost.option.fixedCost': 'Custo Fixo',
  'cost.option.variableCost': 'Custo Variável',
  'cost.option.generalCost': 'Custo Geral',
  'cost.option.budget': 'Orçamento',
  'cost.option.warranty': 'Garantia',
  'cost.option.return': 'Retorno',
  'cost.option.courtesy': 'Cortesia',
  'cost.option.insideCourtesy': 'Interna (Cortesia)',
  'cost.option.totalLoss': 'Perda Total',
  'cost.option.revision': 'Revisão',
  'cost.option.open': 'Abertos',
  'cost.option.liquidated': 'Liquidados',
  'cost.option.emission': 'Emissão',
  'cost.option.dueDate': 'Vencimento',
  'cost.option.payment': 'Pagamento',
};
